export default {
    ACOLHIMENTO_COM_CLASSIFICACAO_DE_RISCO: '0301060118',
    ACOMPANHAMENTO_DA_POPULACAO_INFANTO_JUVENIL_COM_SOFRIMENTO_OU_TRANSTORNOS_MENTAIS_DECORRENTES_DO_USO_DE_CRACK_ALCOOL_E_OUTRAS_DROGAS: '0301080380',
    ACOMPANHAMENTO_DE_PACIENTE_EM_SAUDE_MENTAL: '0301080046',
    ACOMPANHAMENTO_DE_PESSOAS_ADULTAS_COM_SOFRIMENTO_OU_TRANSTORNOS_MENTAIS_DECORRENTES_DO_USO_DE_CRACK_ALCOOL_E_OUTRAS_DROGAS: '0301080372',
    ACOMPANHAMENTO_DE_PESSOAS_COM_NECESSIDADES_DECORRENTES_DO_USO_DE_ALCOOL_CRACK_E_OUTRAS_DROGAS: '0301080364',
    ADMINISTRACAO_DE_MEDICAMENTOS_NA_ATENCAO_ESPECIALIZADA: '0301100012',
    AFERICAO_DE_TEMPERATURA: '0301100250',
    AFERICAO_PRESSAO_ARTERIAL: '0301100039',
    AJUDA_DE_CUSTO_PARA_ALIMENTACAO_DE_ACOMPANHANTE_SEM_PERNOITE: '0803010052',
    AJUDA_DE_CUSTO_PARA_ALIMENTACAO_DE_PACIENTE_SEM_PERNOITE: '0803010028',
    ATEND_URG_ATENCAO_PRIMARIA_OBS_ATE_8_HORAS: '0301060045',
    ATEND_URG_OBS_ATE_24_HORAS_ATENCAO_ESPECIALIZADA: '0301060029',
    AVALIACAO_ANTROPOMETRICA: '0101040024',
    COLETA_DE_MATERIAL_PARA_EXAME_CITOPATOLOGICO_DE_COLO_DE_UTERO: '0201020033',
    COLETA_DE_MATERIAL_PARA_EXAME_LABORATORIAL: '0201020041',
    CURATIVO_DE_DEMORA_C_OU_S_PREPARO_BIOMECANICO: '0307020029',
    CURATIVO_EM_GRANDE_QUEIMADO: '0413010031',
    CURATIVO_EM_MEDIO_QUEIMADO: '0413010040',
    CURATIVO_EM_PEQUENO_QUEIMADO: '0413010058',
    CURATIVO_ESPECIAL: '0214010104',
    CURATIVO_GRAU_II_C_OU_S_DEBRIDAMENTO: '0401010015',
    CURATIVO_SIMPLES: '0301100276',
    DOSAGEM_DE_HEMOGLOBINA_GLICOSILADA: '0202010503',
    EMISSOES_OTOACUSTICAS_EVOCADAS_PARA_TRIAGEM_AUDITIVA_TESTE_DA_ORELHINHA: '0211070149',
    ESCUTA_INICIAL_ORIENTACAO_ACOLHIMENTO_A_DEMANDA_ESPONTANEA: '0301040079',
    FUNDOSCOPIA: '0211060100',
    GLICEMIA_CAPILAR: '0214010015',
    MEDICAO_DE_ALTURA: '0101040075',
    MEDICAO_DE_PESO: '0101040083',
    POTENCIAL_EVOCADO_AUDITIVO_PARA_TRIAGEM_AUDITIVA_TESTE_DA_ORELHINHA: '0211070270',
    RESSONANCIA_MAGNETICA_DE_CRANIO: '0207010064',
    TESTE_RAPIDO_PARA_DETECCAO_DE_INFECCAO_PELO_HBV: '0214010104',
    TOMOGRAFIA_COMPUTADORIZADA_DO_CRANIO: '0206010079',
    ULTRASSONOGRAFIA_DOPPLER_DE_FLUXO_OBSTETRICO: '0205010059',
    ULTRASSONOGRAFIA_OBSTETRICA: '0205020143',
    ULTRASSONOGRAFIA_OBSTETRICA_C_DOPPLER_COLORIDO_E_PULSADO: '0205020151',
    ULTRASSONOGRAFIA_TRANSFONTANELA: '0205020178',
    UNIDADE_DE_REMUNERACAO_PARA_DESLOCAMENTO_DE_ACOMPANHANTE_POR_TRANSPORTE_TERRESTRE: '0803010109',
    UNIDADE_DE_REMUNERACAO_PARA_DESLOCAMENTO_DE_PACIENTE_POR_TRANSPORTE_TERRESTRE: '0803010125',
    MAMOGRAFIA: '0204030030',
    MAMOGRAFIA_BILATERAL_PARA_RASTREAMENTO: '0204030188',
    EXAME_CITOPATOLOGICO_CERVICO_VAGINAL_MICROFLORA: '0203010019',
    EXAME_CITOPATOLOGICO_CERVICO_VAGINAL_MICROFLORA_RASTREAMENTO: '0203010086',
    TIPIFICACAO_DO_ALELO_HLA_B: '0201020068',
    EXAME_CITOPATOLOGICO_HORMONAL_SERIADO_MINIMO_3_COLETAS: '0203010027',
    EXAME_CITOPATOLOGICO_DE_MAMA: '0203010043',
}
